module.exports = __webpack_public_path__ + "media/25.fd696d07.mp3";